import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconArrowBottomTop: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconArrowBottomTop"><Path fillRule="evenodd" clipRule="evenodd" d="M17.0002 2.58594L22.4144 8.00015L21.0002 9.41436L18.0002 6.41436V21.0002H16.0002V6.41436L13.0002 9.41436L11.5859 8.00015L17.0002 2.58594ZM8.00015 3.00015V17.5859L11.0002 14.5859L12.4144 16.0002L7.00015 21.4144L1.58594 16.0002L3.00015 14.5859L6.00015 17.5859V3.00015H8.00015Z" fill="currentColor"/></CentralIconBase>;
});

export default IconArrowBottomTop;
